export function storeUserInterfaceInfo(ui) {
  return {
    type: "set",
    payload: ui,
  };
}

export function getUserInterfaceInfo() {
  return {
    type: "get",
  };
}
